mutation RemoveMetadata($computedDeliverableIdentifiers: [InputComputedDeliverableIdentifier!]!, $fieldId: ID!) {
    removeMetadata(computedDeliverableIdentifiers: $computedDeliverableIdentifiers, fieldId: $fieldId)
}
